export const DEFAULT_TYPE = 'GENERIC';
export const DEFAULT_FILE_NAME = 'unknown.txt';
